var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "550" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("auto-config-title")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            { attrs: { white: "" }, on: { click: _vm.close } },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      !_vm.config
        ? _c(
            "w-card-content",
            [
              _vm.error
                ? _c("b", { staticClass: "mb error" }, [
                    _vm._v(
                      _vm._s(_vm.$ct("auto-config-labels.not-found-title")) +
                        ' "' +
                        _vm._s(_vm.email) +
                        '" '
                    ),
                  ])
                : _vm._e(),
              _vm.isGoogle
                ? _c("b", { staticClass: "mb error" }, [
                    _vm._v(_vm._s(_vm.$ct("auto-config-messages.is-gmail"))),
                  ])
                : _vm._e(),
              _vm.isOutlook
                ? _c("b", { staticClass: "mb error" }, [
                    _vm._v(_vm._s(_vm.$ct("auto-config-messages.is-outlook"))),
                  ])
                : _vm._e(),
              _c("w-input", {
                staticClass: "mb",
                attrs: {
                  label: _vm.$ct("auto-config-labels.email"),
                  fancy: "",
                },
                on: {
                  focus: function ($event) {
                    _vm.error = false
                  },
                },
                model: {
                  value: _vm.email,
                  callback: function ($$v) {
                    _vm.email = $$v
                  },
                  expression: "email",
                },
              }),
              _c("w-input", {
                attrs: {
                  "has-error": _vm.isRequired,
                  label: _vm.$ct("auto-config-labels.password"),
                  password: !_vm.showPassword,
                  autocomplete: "new-password",
                  fancy: "",
                  icon: "eye",
                  required: "",
                },
                on: {
                  focus: function ($event) {
                    _vm.isRequired = false
                  },
                  "icon-click": function ($event) {
                    _vm.showPassword = !_vm.showPassword
                  },
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.config
        ? _c(
            "w-card-content",
            [
              !_vm.error
                ? _c("b", [
                    _vm._v(
                      _vm._s(_vm.$ct("auto-config-labels.found-title")) +
                        ' "' +
                        _vm._s(_vm.email) +
                        '" '
                    ),
                  ])
                : _vm._e(),
              _c("w-input", {
                staticClass: "mt",
                attrs: { label: _vm.$ct("auto-config-labels.host"), fancy: "" },
                model: {
                  value: _vm.config.Host,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "Host", $$v)
                  },
                  expression: "config.Host",
                },
              }),
              _c("w-input-number", {
                staticClass: "mts",
                attrs: {
                  decimals: 0,
                  label: _vm.$ct("auto-config-labels.port"),
                  fancy: "",
                },
                model: {
                  value: _vm.config.Port,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "Port", $$v)
                  },
                  expression: "config.Port",
                },
              }),
              _c("w-input", {
                staticClass: "mts",
                attrs: {
                  label: _vm.$ct("auto-config-labels.encryption"),
                  fancy: "",
                },
                model: {
                  value: _vm.config.Encryption,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "Encryption", $$v)
                  },
                  expression: "config.Encryption",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-card-actions",
        [
          _c("w-button", { staticClass: "cancel", on: { click: _vm.close } }, [
            _vm._v(_vm._s(_vm.$ct("common.cancel"))),
          ]),
          _c("w-spacer"),
          !_vm.config
            ? _c(
                "w-button",
                {
                  attrs: { disabled: _vm.pending },
                  on: {
                    click: function ($event) {
                      return _vm.start()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("auto-config-labels.search")))]
              )
            : _vm._e(),
          _vm.config
            ? _c(
                "w-button",
                {
                  attrs: { disabled: _vm.pending },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("auto-config-labels.save")))]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }